module.exports = __webpack_public_path__ + "img/Background-Wood-Panel-Boards-no-text-jpg.55bfd185.webp";